/*
 * ---------------------------------------------------------------------------
 * COMMERCIAL IN CONFIDENCE
 *
 * (c) Copyright Quosient Ltd. All Rights Reserved.
 *
 * See LICENSE.txt in the repository root.
 * ---------------------------------------------------------------------------
 */

// Climate and weather data

/*
* C block for land cover and land use map selection
*/
import * as Blockly from 'blockly/core';
import 'blockly/python';
import { getAllowedStatements } from '../block_compatibility_checks';

Blockly.Blocks['input_climate_data_only'] = {
    init: function () {
        this.appendDummyInput()
            .appendField('Weather and climate data: ')
            .appendField(new Blockly.FieldDropdown([
                ['Daily Global Land Data Assimilation System', 'gldas'],
                ['Ocean Color SMI: Daily MODIS Aqua Data', 'chlorophyll'],
                ['S-5 Near Real Time Cloud Data', 'nrti_cloud'],
                ['Daily NOAA Ocean Near-Surface Air Atmospheric Properties', 'noaa_ocean'],
                ['Terra Daily Snow Cover 500m', 'snow_cover']]),
                "dropdown")


        this.appendStatementInput("do")
            .setCheck(getAllowedStatements('other_data_only'))
        this.setInputsInline(false);
        this.setStyle('input');
        this.setTooltip(Blockly.Msg.CLIMATE_DATA_ONLY_BLOCK_TOOLTIP);
        this.setHelpUrl("");
    },
};